import React, { useState, useCallback, useEffect, useMemo } from 'react';
import moment from 'moment';
import Filter from '@/pages/intelligence/components/Filter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { handleExtendTimeFilterValue,  updateInputListRangeTime } from '@intelligence/utils/filterUtils';
import { useUpdateFilterFormValues } from '@intelligence/hooks/useUpdateFilterFormValues';


export default function PhysicalRevenueDetailFilter(props: any) {
  const {
    timeFilterValues,
    filterConfirm,
    filterReset,
    filterInit,
    buttonLogConfig,
    latestedReleaseDate,
    entityType,
    sinceReleaseTime,
    earliestDataTime,
    hasDevice,
    deviceDefVales,
    deviceOptions = [],
  } = props;

  const defaultValue = {
    [filterKeyMap.RANGE_TIME]: {
      type: 'month',
      value: ['', ''],
    },
    [filterKeyMap.PHYSICAL_DEVICE]: {
      value: deviceDefVales,
    },
  };
  // 继承逻辑在这写
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend(
    {},
  );

  const [extendDefaultValue] = useState(!isOperateDetail
    ? defaultValue
    : {

      [filterKeyMap.RANGE_TIME]: {
        type: 'month',
        value: handleExtendTimeFilterValue({
          // 仅有月粒度，单选1个月
          onlyMonth: true,
          extendFilterValues: detailFilterExtend[filterKeyMap.RANGE_TIME],
          defaultValue: defaultValue[filterKeyMap.RANGE_TIME]?.value,
        }),
      },
      [filterKeyMap.PHYSICAL_DEVICE]: {
        value:
          detailFilterExtend[filterKeyMap.PHYSICAL_DEVICE]?.value ?? defaultValue[filterKeyMap.PHYSICAL_DEVICE]?.value,
      },
    });

  const [formValue, setFormValue] = useState(extendDefaultValue);

  const defaultInputList = {
    RANGE_TIME: {
      type: filterKeyMap.RANGE_TIME,
      key: filterKeyMap.RANGE_TIME,
      calendarType: 'month',
      showSelectType: false,
      // showShortcut: false,
      default: [
        moment().subtract(6, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
      earliestDataTime,
      sinceReleaseTime,
      isShowAlloftime: false,
    },
    PHYSICAL_DEVICE: {
      key: filterKeyMap.PHYSICAL_DEVICE,
      type: filterKeyMap.CONSOLE_DEVICE,
      options: deviceOptions,
      default: defaultValue[filterKeyMap.PHYSICAL_DEVICE],
    },
  };
  const list = [];
  list.push(defaultInputList.RANGE_TIME);
  if (hasDevice) {
    list.push(defaultInputList.PHYSICAL_DEVICE);
  }
  const [inputList, setInputList] = useState(list);

  useEffect(() => {
    /** 更新时间筛选器快捷键 */
    if (inputList) {
      const updateOptionInput = updateInputListRangeTime({
        inputList,
        key: filterKeyMap.RANGE_TIME,
        earliestDataTime,
        sinceReleaseTime,
      });
      setInputList(updateOptionInput);
    }
  }, [earliestDataTime, sinceReleaseTime]);

  /** 时间筛选器值由父组件更新 */
  const combinedValues = useUpdateFilterFormValues({
    formValue,
    timeFilterValues,
  });

  useEffect(() => {
    setFormValue(combinedValues);
  }, [JSON.stringify(combinedValues)]);

  const onConfirm = useCallback(
    (value, apiValue) => {
      setFormValue(value);
      /** 修改筛选器值转换为接口参数 */
      const filterForm: any = {
        date_type: apiValue[filterKeyMap.RANGE_TIME]?.granularity,
        start_date: apiValue[filterKeyMap.RANGE_TIME]?.start_date,
        end_date: apiValue[filterKeyMap.RANGE_TIME]?.end_date,
      };
      if (hasDevice) {
        filterForm.device = value[filterKeyMap.PHYSICAL_DEVICE]?.value;
      }
      filterConfirm(filterForm);
      setDetailFilterExtend(apiValue);
    },
    [filterConfirm],
  );

  return (
    <Filter
      value={formValue}
      inputList={inputList}
      // onInit={onInit}
      onConfirm={onConfirm}
      onReset={() => { }}
      showButton={false}
      defaultValue={defaultValue}
    />
  );
}
